import { render, staticRenderFns } from "./shoppingCar.vue?vue&type=template&id=674a6a6b&scoped=true&"
import script from "./shoppingCar.vue?vue&type=script&lang=js&"
export * from "./shoppingCar.vue?vue&type=script&lang=js&"
import style0 from "./shoppingCar.vue?vue&type=style&index=0&id=674a6a6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a6a6b",
  null
  
)

export default component.exports